import { SelectedDaysType } from '../CalendarPanel';

export interface CalendarPanelFooterProps {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** Defines primary (submit) action label */
  primaryActionLabel: string;
  /** Defines secondary (cancel) action label */
  secondaryActionLabel: string;
  /** Specifies whether primary action is disabled */
  primaryActionDisabled: boolean;
  /** Defines a callback function which is called every time primary button is clicked */
  primaryActionOnClick: React.MouseEventHandler<HTMLButtonElement>;
  /** Defines a callback function which is called every time secondary button is clicked */
  secondaryActionOnClick: React.MouseEventHandler<HTMLButtonElement>;
  /** Defines an active date or a date range selection */
  selectedDays?: SelectedDaysType;
  /** Formats date into a string for displaying the current selected days. Receives a Date instance. */
  dateToString: (date: Date) => string;
}
